// extracted by mini-css-extract-plugin
module.exports = {"center":"main_center__O9dWL","logo":"main_logo__3-yha","donate":"main_donate__2rVU9","btn":"main_btn__3Lp6s"};